export default __webpack_public_path__ + "static/media/cloudy.a3c0e416.jpg";